import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet';
import Axios from 'axios';
import { Turnstile } from '@marsidev/react-turnstile';

import { urlAPIAgaric, urlBase } from "./../config/Globals";

import maison from './../assets/images/maison.svg';
import imageContact from './../assets/images/image-contact.jpg';

import { Partenaires } from "./Home/Partenaires";
import ContactService from "../service/ContactService";

export const Contact = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const uuid = queryParams.get('uuid');

    const [formStatus, setFormStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState(null);
    const turnstileRef = useRef(null);

    const [formContact, setFormContact] = useState({
        civilite: "",
        nom: "",
        prenom: "",
        email: "",
        telephone: "",
        objet: "",
        message: "",
        transmission: false
    });

    const handleChange = ({ currentTarget }) => {
        const { value, name } = currentTarget;
        setFormContact({ ...formContact, [name]: value });
    }

    const handleChangeCheckbox = ({ target }) => {
        setFormContact(formContact => ({ ...formContact, [target.name]: !formContact[target.name] }));
    }

    const handleSubmit = async event => {
        event.preventDefault();

        if (!turnstileToken) {
            alert("Veuillez valider le contrôle de sécurité (Captcha).");
            return;
        }

        setIsSubmitting(true);

        let url = '';
        //if (uuid) url = urlAPIAgaric + "messages/" + uuid;
        if (uuid) url = urlAPIAgaric + "messages/prospections";
        else url = urlAPIAgaric + "messages";

        url+='?verification='+turnstileToken;

        try {
            //console.log("Données envoyées :", formContact);
            const response = await Axios.post(url, formContact);
            const retour = response.data;
            //console.log("Retour API :", retour);

            // 🟢 SUCÈS (Codes 200, 201...)
            setFormStatus({
                type: 'success',
                text: "Votre demande a bien été prise en compte."
            });

            // Réinitialisation du formulaire
            setFormContact({
                civilite: "", nom: "", prenom: "", email: "", telephone: "", objet: "", message: "",transmission: false
            });
            setTurnstileToken(null);
            turnstileRef.current?.reset();

        } catch (error) {
            //console.error("Erreur lors de l'envoi :", error);

            // Sécurité : On réinitialise toujours le captcha en cas d'échec
            turnstileRef.current?.reset();
            setTurnstileToken(null);

            // TRAITEMENT DES ERREURS PAR CODE HTTP
            if (error.response) {
                const status = error.response.status;
                const apiMessage = error.response.data?.detail; // Message personnalisé venant de FastAPI

                switch (status) {
                    case 400:
                        // Captcha invalide, jeton expiré ou mauvaise syntaxe globale
                        setFormStatus({
                            type: 'error',
                            text: apiMessage || "Le contrôle de sécurité (Captcha) a échoué. Veuillez réessayer."
                        });
                        break;

                    case 422:
                        // Erreur de validation automatique de FastAPI / Pydantic
                        setFormStatus({
                            type: 'error',
                            text: "Certains champs sont incorrects (ex: format de l'email ou numéro de téléphone invalide)."
                        });
                        break;

                    case 429:
                        // Trop de requêtes (Rate-limiting mis en place sur ton FastAPI)
                        setFormStatus({
                            type: 'error',
                            text: "Trop de tentatives d'envoi. Veuillez patienter quelques minutes avant de recommencer."
                        });
                        break;

                    case 500:
                    case 502:
                    case 503:
                        // Erreurs serveurs (Ex: FastAPI n'arrive pas à joindre ton serveur SMTP d'envoi de mail)
                        setFormStatus({
                            type: 'error',
                            text: "Notre serveur rencontre un problème technique temporaire. Veuillez nous en excuser."
                        });
                        break;

                    default:
                        // Autres codes HTTP d'erreur
                        setFormStatus({
                            type: 'error',
                            text: apiMessage || `Une erreur inattendue est survenue (Erreur ${status}).`
                        });
                }
            } else if (error.request) {
                // Le serveur n'a pas répondu du tout (Panne réseau totale, mauvaise URL de base, etc.)
                setFormStatus({
                    type: 'error',
                    text: "Impossible de contacter le serveur. Vérifiez votre connexion internet."
                });
            } else {
                // Erreur de configuration dans le code React avant l'envoi
                setFormStatus({
                    type: 'error',
                    text: "Une erreur interne est survenue lors de la préparation de l'envoi."
                });
            }
        } finally {
            setIsSubmitting(false);
            window.scrollTo(0, 0);
        }
    }

    return (
        <>
            <Helmet>
                <title>Contact</title>
                <meta name="description" content="Si vous avez une question, vous pouvez nous adresser un message" />
            </Helmet>
            <main className="type contact">
                <section className="bg-gris pb-5">
                    <div className="container px-4 pb-5 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            Contact
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="display-5 fw-bold mb-3">Contact</h1>
                                <div className="fw-bold fs-6">
                                    <p>Si vous avez une question, vous pouvez nous adresser un message en remplissant le formulaire ci-dessous :</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-0 align-items-stretch justify-content-center">
                            <div className="col-12 col-lg-4 bg-image-contact" style={{ backgroundImage: `url(${imageContact})` }}></div>

                            <div className="col-12 col-lg-7 bg-white p-4 p-md-5 d-flex flex-wrap justify-content-center align-items-center">
                                {formStatus && (
                                    <div className={`alert ${formStatus.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show my-3`} role="alert">
                                        {formStatus.text}
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setFormStatus(null)}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}
                                <form method="post" className="col-12 col-lg-10" onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2">Civilité*</label>
                                        <div className="d-flex gap-4">
                                            <div className="form-check">
                                                <input required className="form-check-input" name="civilite" value="M." type="radio" id="civ_m" checked={formContact.civilite === "M."} onChange={handleChange} />
                                                <label htmlFor="civ_m" className="form-check-label">M.</label>
                                            </div>
                                            <div className="form-check">
                                                <input required className="form-check-input" name="civilite" type="radio" value="Mme" id="civ_mme" checked={formContact.civilite === "Mme"} onChange={handleChange} />
                                                <label htmlFor="civ_mme" className="form-check-label">Mme</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fcnom">Nom*</label>
                                        <input type="text" id="fcnom" name="nom" value={formContact.nom} onChange={handleChange} className="form-control custom-input" placeholder="Votre Nom" required autoComplete="family-name" />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fcprenom">Prénom*</label>
                                        <input type="text" id="fcprenom" name="prenom" value={formContact.prenom} onChange={handleChange} className="form-control custom-input" placeholder="Votre Prénom" required autoComplete="given-name" />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fcemail">Email*</label>
                                        <input id="fcemail" name="email" type="email" value={formContact.email} onChange={handleChange} className="form-control custom-input" placeholder="Votre Email" required />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fctelephone">Téléphone*</label>
                                        <input name="telephone" id="fctelephone" value={formContact.telephone} onChange={handleChange} type="tel" className="form-control custom-input" required />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fcobjet">Objet*</label>
                                        <input name="objet" id="fcobjet" value={formContact.objet} onChange={handleChange} type="text" className="form-control custom-input" placeholder="Votre objet" required />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-bold mb-2" htmlFor="fcmessage">Message</label>
                                        <textarea name="message" id="fcmessage" value={formContact.message} onChange={handleChange} className="form-control custom-textarea" maxLength="800" placeholder="Votre message" rows="6"></textarea>
                                    </div>

                                    <div className="mb-4">
                                        <div className="form-check">
                                            <input className="form-check-input" name="transmission" id="fctransmission" type="checkbox" checked={formContact.transmission} onChange={handleChangeCheckbox} />
                                            <label htmlFor="fctransmission" className="form-check-label small lh-sm text-muted">J’accepte que les informations recueillies soient transmises au Bureau Interprofessionnel des Vins de Bourgogne</label>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center my-4">
                                        <Turnstile
                                            ref={turnstileRef}
                                            siteKey="0x4AAAAAADnEs1RdaUdQs73J"
                                            onSuccess={(token) => setTurnstileToken(token)}
                                            onExpire={() => setTurnstileToken(null)}
                                            onError={() => setTurnstileToken(null)}
                                            options={{
                                                execution: 'render'
                                            }}
                                        />
                                    </div>

                                    <div className="text-center my-4">
                                        <input
                                            type="submit"
                                            className="btn btn-warning mx-auto mt-4"
                                            value={isSubmitting ? "Envoi en cours..." : "Envoyer"}
                                        />
                                    </div>
                                </form>

                                <div className="text-muted small border-top pt-4 mt-4 lh-base text-justify col-12 col-lg-10">
                                    <p className="mb-3">Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par le Bureau Interprofessionnel des Vins de Bourgogne pour le traitement de votre demande et de futures communications...</p>
                                    <p className="mb-0">Pour connaître et exercer vos droits... veuillez consulter notre <a href={urlBase + 'politique-protection'} className="link-rgpd">Politique de protection des données personnelles.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Partenaires />
            </main>
        </>
    )
}